import Immutable from 'seamless-immutable';
import { RETRIEVE_CUSTOMER_CHALLENGE_ANSWER } from './actions/customer.challenge.actions';
export var INITIAL_STATE = Immutable({
  challengeAnswerError: null,
  data: null,
  isFetchingChallengeAnswer: false
});
export default function challengeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.BEGIN:
      return state.set('isFetchingChallengeAnswer', true);
    case RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.SUCCESS:
      return state.set('isFetchingChallengeAnswer', false).set('data', payload.ChallengeAnswer).set('challengeAnswerError', null);
    case RETRIEVE_CUSTOMER_CHALLENGE_ANSWER.FAILURE:
      return state.set('isFetchingChallengeAnswer', false).set('challengeAnswerError', {
        code: payload.Code,
        message: payload.Message,
        severity: payload.Severity,
        translatedMessage: payload.translatedMessage
      });
    default:
      return state;
  }
}